<ng-container *ngIf="isQuickCreateEnabled()">
    <br><button type="button" class="btn btn-outline-secondary mb-3" (click) = "stepCreate()" translate>stepper.action.create</button>
</ng-container>

<br>

<help-alert text = "help.page.organization.field" info = "help.info" description = "help.page.organization.description"></help-alert>

<div *ngIf="_organization_detail" class="card">

    <div class="card-header">
        <span translate>organization.name.info</span>
    </div>

    <div class="card-body">


        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.name</mat-label>
            <input [(ngModel)]="_organization_detail.name" matInput>
        </mat-form-field>

        <br>
    
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.vatRegistration</mat-label>
            <input [(ngModel)]="_organization_detail.vatRegistration" matInput>
        </mat-form-field>

        <br>

        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.billAddress</mat-label>
            <input [(ngModel)]="_organization_detail.billAddress" matInput>
        </mat-form-field>
        
        <br>
    
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.zipcode</mat-label>
            <input [(ngModel)]="_organization_detail.zipCode" matInput>
        </mat-form-field>
        
        <br>
    
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.billEmail</mat-label>
            <input [(ngModel)]="_organization_detail.billEmail" matInput>
        </mat-form-field>
    
        <br>
    
        <mat-form-field class = "full-width">
            <mat-label translate>organization.field.billPhone</mat-label>
            <input [(ngModel)]="_organization_detail.billPhone" matInput>
        </mat-form-field>
    
        <br>

        <place-autocomplete     #autocompleteManager 
                                [preselect]     =   "{id: _organization_detail.placeId, name: _organization_detail.placeName}"
                                (placeChange)   =   "placeChanged($event)"> </place-autocomplete>
     
        <br>

        <mat-checkbox [(ngModel)]="advanced" *ngIf="_organization_detail?.url">
            <span translate>organization.field.advanced</span>
        </mat-checkbox>

        <ng-container *ngIf="advanced">
            
            <mat-form-field class = "full-width mt-3">
                <mat-label translate>organization.field.code</mat-label>
                <input [(ngModel)]="_organization_detail.code" matInput disabled>
            </mat-form-field>

            <ng-container *ngIf="_organization_detail.code"> 
                <div class="alert alert-primary mt-2">
                    <p translate>organization.field.code_info</p>
                    <a>{{_organization_detail.url}}</a> <!-- generateLoginUrl() https://webapp.codaq.it/release/webapp/#/login?code={{_organization_detail.code}} -->
                </div>
            </ng-container>

        </ng-container>

        <br>
    
        <!--
        <mat-checkbox class = "full-width" [(ngModel)]="_organization_detail.enabled">
            <span translate>organization.field.enable</span>
        </mat-checkbox>
        -->
    </div>

    <div class="card-footer">
        <button type="button" class="btn btn-outline-secondary float-right" (click) = "update()" translate>organization.action.save</button>
    </div>
</div>